module.exports = __webpack_public_path__ + "img/ai-park.e832f305.jpg";